module.exports = __webpack_public_path__ + "img/section6.81b85575.png";